import React, { useEffect, useState } from "react";
import axios from "axios";

const Partner = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [partners, setPartners] = useState([]);
    const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes in milliseconds

    useEffect(() => {
        // Check if partners data is available in localStorage
        const cachedData = JSON.parse(localStorage.getItem('partnersData'));

        if (cachedData) {
            const { data, timestamp } = cachedData;

            // Check if the cached data has expired (older than 30 minutes)
            const currentTime = Date.now();
            if (currentTime - timestamp < cacheExpiryTime) {
                // If not expired, use the cached data
                setPartners(data);
            } else {
                // If expired, clear the cache and fetch new data
                localStorage.removeItem('partnersData');
                fetchPartners();
            }
        } else {
            // If no cache, fetch data from the API
            fetchPartners();
        }
    }, []);

    const fetchPartners = () => {
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const Url = process.env.REACT_APP_API_VISA_PARTNER;

        axios.get(`${apiBaseUrl}${Url}`)
            .then(response => {
                const newData = response.data;
                // Save the fetched data along with the current timestamp in localStorage
                localStorage.setItem('partnersData', JSON.stringify({
                    data: newData,
                    timestamp: Date.now(),
                }));
                setPartners(newData);
            })
            .catch(error => {
                console.error("Error fetching API", error);
            });
    };

    return (
        <section className="partners-area pt-80 pb-80" style={{ backgroundColor: '#ffffff' }}>
            <div className="container">
                {/* Modern Section Header (Matched with previous sections) */}
                <div className="row justify-content-center">
                    <div className="col-lg-8 text-center">
                        <span className="text-primary fw-bold text-uppercase" style={{ letterSpacing: '2px', fontSize: '0.9rem' }}>
                            Global Collaborations
                        </span>
                        <h2 className="display-6 fw-bold text-dark mt-2 mb-3">Our Partners</h2>
                        <div className="bg-primary mx-auto" style={{ width: '60px', height: '3px', borderRadius: '2px' }}></div>
                    </div>
                </div>

                {/* Partners Grid */}
                <div className="row g-4 justify-content-center align-items-center">
                    {partners.map((partner, index) => {
                        return (
                            <div className="col-6 col-md-4 col-lg-2" key={index}>
                                <div
                                    className="partner-card bg-white p-3 rounded-4 shadow-sm text-center d-flex align-items-center justify-content-center"
                                    style={{
                                        height: '110px',
                                        border: '1px solid rgba(0, 0, 0, 0.05)',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-5px)';
                                        e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.08)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                                    }}
                                >
                                    <img
                                        className="img-fluid"
                                        src={`${backendBaseUrl}${partner?.image}`}
                                        alt={partner?.name || "Partner Logo"}
                                        style={{ maxHeight: '60px', objectFit: 'contain', filter: 'grayscale(20%)', transition: 'filter 0.3s ease' }}
                                        onMouseOver={(e) => e.currentTarget.style.filter = 'grayscale(0%)'}
                                        onMouseOut={(e) => e.currentTarget.style.filter = 'grayscale(20%)'}
                                    />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}

export default Partner;